import { useState, useEffect } from 'react';
export const useIsLayoutReady = () => {
    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    }, []);
    return isReady;
};
